import { useSessionOrNull } from '~/contexts/SessionContext';
import { StructureSetId } from '~/domain/changes/ids';
import { createRoiListItemView } from '~/domain/projections/factories';
import { RoiListItemView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

const NO_ITEMS: readonly RoiListItemView[] = [];

/**
 * Subscribe to the ROI list of a structure set. Returns an empty list
 * when there is no active session. Properties surfaces (e.g. the Setup
 * step's dataset list) mount before PatientSessionProvider's effect
 * creates one.
 */
export function useRoiListView(
    ssId: StructureSetId | undefined
): readonly RoiListItemView[] {
    return useDomainProjection(
        useSessionOrNull(),
        'useRoiListView',
        [ssId],
        (patient) => {
            const ss =
                ssId === undefined
                    ? undefined
                    : patient.getStructureSetById(ssId);
            return ss ? ss.rois.map(createRoiListItemView) : NO_ITEMS;
        },
        NO_ITEMS
    );
}
